module.exports = __webpack_public_path__ + "img/moneymex_desc_vi1.84b2fe65.webp";